<template>
  <div class="zyc-checkbox-group">
    <div :id="id">
      <el-checkbox-group v-model="val">
        <el-checkbox v-for="i in data"  :label="i.value" :key="i.value" @change="checkboxChange(i,$event)">{{ i.label }}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div style="clear:both;"></div>
  </div>
</template>
<script>
  
  /**
  * 多选组
  */
  export default {
    name: 'zycCheckboxGroup',
    props: {
      data: {
        type: Array,
        default: () => []
      },
      value: {
        type: Array,
        default: () => []
      },
      checkboxGroupChange: {
        type: Function,
        default: () => { }
      }
    },
    model: {
      prop: 'value',
      event: 'valueChange', 
    },
    watch: {
      data: {
        handler: function (newVal, oldVal) {
          this.list = newVal
        },
        immediate: true
      },
      value: {
        handler: function (newVal, oldVal) {
          this.val = newVal
        },
        immediate: true
      }
    },
    data() {
      return {
        id: Math.random().toString(36).slice(2),
        list: [],
        val: this.value
      }
    },
    mounted() {

    },
    created() {
    },
    methods: {
      checkboxChange: function (val, obj) {
        this.$emit('valueChange', this.val)
        this.checkboxGroupChange(this.val, val, obj)
      },
      removeVal: function (val) {
        this.val.forEach((el, i) => {
          if (el == val) {
            this.val.splice(i, 1)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/checkbox/checkboxGroup.vue